import * as React from "react";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import Card from "../core/Card";
import { CoachesForm } from "../coaches/CoachesForm";

interface IProps {
  userContext: IUserContextData;
  cwCompanyId: string;
  cwRecId: string;
}

interface IState {
  submitted: boolean;
}

class CoachesCenter extends React.Component<IProps, IState> {
  state: IState = {
    submitted: false,
  };

  setSubmitted = () => {
    this.setState({
      submitted: true,
    });
  };

  render() {
    const { userContext, cwCompanyId, cwRecId } = this.props;
    const userData = userContext.user.data.attributes;

    return (
      <PageContainer>
        <Breadcrumbs crumbs={[{ label: "Coaches Center" }]} />
        <Card title={"Get in touch with our Experts!"}>
          {this.state.submitted ? (
            <div>Thanks for reaching out, we'll contact you shortly!</div>
          ) : (
            <CoachesForm
              setSubmitted={this.setSubmitted}
              userData={userData}
              cwCompanyId={cwCompanyId}
              cwRecId={cwRecId}
            />
          )}
        </Card>
      </PageContainer>
    );
  }
}

export default CoachesCenter;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/CoachesCenter.tsx